<div class="warehouse-selector">
  <div class="header">
    <div class="title">{{ product?.ItemName }}</div>
    <div class="subtitle">{{ product?.ItemCode }}</div>
  </div>

  <nz-spin [nzSpinning]="isLoading">
    <nz-alert
      *ngIf="errorMessage"
      nzType="error"
      [nzMessage]="errorMessage"
      nzShowIcon
    ></nz-alert>

    <nz-empty
      *ngIf="!isLoading && !errorMessage && warehouses.length === 0"
      nzNotFoundContent="No warehouses available"
    ></nz-empty>

    <div class="options" *ngIf="warehouses.length > 0">
      <label
        class="option"
        *ngFor="let warehouse of warehouses; trackBy: trackByWarehouseCode"
        [class.selected]="selectedWarehouseCode === warehouse.WarehouseCode"
      >
        <input
          type="radio"
          name="warehouse"
          [value]="warehouse.WarehouseCode"
          [checked]="selectedWarehouseCode === warehouse.WarehouseCode"
          (change)="selectWarehouse(warehouse)"
        />
        <span class="warehouse-icon" aria-hidden="true">
          <i class="fa fa-warehouse"></i>
        </span>
        <span class="warehouse-details">
          <span class="warehouse-name">
            {{ warehouse.WarehouseName || warehouse.WarehouseCode }}
          </span>
          <span class="warehouse-code">{{ warehouse.WarehouseCode }}</span>
        </span>
      </label>
    </div>

    <div class="footer" *ngIf="warehouses.length > 0">
      <button
        nz-button
        nzType="primary"
        (click)="submit()"
        [disabled]="!selectedWarehouse"
      >
        Submit
      </button>
    </div>
  </nz-spin>
</div>
